// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"50693d8f","958":"50693d8f"}[chunkId] + ".chunk.css";
};